import { observable, action, runInAction } from 'mobx'
import API from '@api/hotel/order'
import { hashHistory } from 'react-router'

class Store {
  @observable loading = true
  @observable list = []
  @observable tabStatus = ''
  @observable tabkey = 'all'
  @observable dataTime

  @observable
  form = {
    phone: '',
    name: '',
    order_no: '',
    status: 'all',
    created_from: '',
    created_to: ''
  }

  @observable _ts = ''
  @observable _time = {}

  @action
  formatSeconds = ($ts, $id) => {
    let _t
    let _ts = this._time[$ts] - 1
    let theTime = parseInt(_ts)
    let theTime1 = 0
    let theTime2 = 0
    if (theTime > 60) {
      theTime1 = parseInt(theTime / 60)
      theTime = parseInt(theTime % 60)

      if (theTime1 > 60) {
        theTime2 = parseInt(theTime1 / 60)
        theTime1 = parseInt(theTime1 % 60)
      }
    }
    let result = '' + parseInt(theTime) + '秒'
    if (theTime1 > 0) {
      result = '' + parseInt(theTime1) + '分' + result
    }
    if (theTime2 > 0) {
      result = '' + parseInt(theTime2) + '小时' + result
    }
    _t = setTimeout(() => {
      this._time[$ts] = _ts
      this.formatSeconds($ts, $id)
    }, 1000)

    if (this._time[$ts] == 0 || this._time[$ts] < 0) {
      clearTimeout(_t)
      result = '已过期'
      document.getElementById($id + 'btn').innerHTML = result
      let _name = document.getElementsByName($id)
      _name[0].innerHTML = '过期订单'
    }

    if (document.getElementById($id)) {
      document.getElementById($id).innerHTML = result
    }
  }

  @action
  setStatus = e => {
    this.form.status = e
  }

  @action
  setTabs = e => {
    this.tabkey = e
  }

  @action
  callback = key => {
    this.loading = true
    let _s = this.form.status
    if (_s == 'all') {
      _s = ''
    }
    this.OrderAction('tab=' + key + '&status=' + _s + '&per_page=10')
    this.tabkey = key
    hashHistory.replace(
      '/localMerchant/myOrder?tab=' +
        this.tabkey +
        '&status=' +
        this.form.status
    )
  }

  @action
  getPhone = e => {
    this.form.phone = e.target.value
  }

  @action
  getName = e => {
    this.form.name = e.target.value
  }

  @action
  getOrder = e => {
    this.form.order_no = e.target.value
  }

  @action
  getStatus = e => {
    this.form.status = e
    hashHistory.replace(
      '/localMerchant/myOrder?tab=' + this.tabkey + '&status=' + e
    )
  }

  @action
  getCreat = (date, dateString) => {
    this.dataTime = date
  }

  @action
  searchFrom = () => {
    this.loading = true
    if (this.dataTime) {
      this.form.created_from = this.dataTime[0].format('YYYY-MM-DD')
      this.form.created_to = this.dataTime[1].format('YYYY-MM-DD')
    }
    let _s = this.form.status
    if (_s == 'all') {
      _s = ''
    }
    this.OrderAction(
      'tab=' +
        this.tabkey +
        '&' +
        '_name=' +
        this.form.name +
        '&' +
        '_phone=' +
        this.form.phone +
        '&' +
        'order_no=' +
        this.form.order_no +
        '&' +
        'status=' +
        _s +
        '&' +
        'created_from=' +
        this.form.created_from +
        '&' +
        'created_to=' +
        this.form.created_to +
        '&per_page=10'
    )
  }

  @action
  searchRest = () => {
    this.loading = true
    this.form = {
      phone: '',
      name: '',
      order_no: '',
      status: 'all',
      created_from: '',
      created_to: ''
    }
    this.dataTime = null
    this.OrderAction('tab=' + this.tabkey)
  }

  @action
  paging = type => ({ current }) => {
    this['pagination_' + type].current = current
    //this.OrderAction('tab='+type+'&page='+current+'&per_page=10')
    let _s = this.form.status
    if (_s == 'all') {
      _s = ''
    }
    this.OrderAction(
      'tab=' + type + '&page=' + current + '&status=' + _s + '&per_page=10'
    )
  }

  @action
  OrderAction = async params => {
    let paramsCont = this.getParams(params)
    let _tab = paramsCont['tab']
    let _page = paramsCont['page']
    let {
      data: { list, total_count }
    } = await API.OrderSub(params)
    runInAction('order', () => {
      list.forEach(v => {
        if (v.time_remain != 0) {
          this._time[v.id] = v.time_remain
        }
      })

      this.loading = false
      this.list = list
      this['pagination_' + _tab].total = +total_count
      this['pagination_' + _tab].current = parseInt(_page)
      hashHistory.replace(
        '/localMerchant/myOrder?tab=' +
          this.tabkey +
          '&status=' +
          this.form.status
      )
    })
  }

  //全部订单
  @observable
  pagination_all = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //高意向
  @observable
  pagination_level_high = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //未跟进
  @observable
  pagination_not_following = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //拨打未接通
  @observable
  pagination_not_connected = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //已到店
  @observable
  pagination_is_come = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  @observable
  pagination_refund = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  @action
  getParams = str => {
    let getParams
    let match
    let pl = /\+/g
    let search = /([^&=]+)=?([^&]*)/g
    let decode = function(s) {
      return decodeURIComponent(s.replace(pl, ' '))
    }
    let query = str
    getParams = {}
    // eslint-disable-next-line
    while ((match = search.exec(query)))
      getParams[decode(match[1])] = decode(match[2])
    return getParams
  }
}

export default new Store()
